import React from 'react';
import { observer } from 'mobx-react';
import { Outlet } from 'react-router-dom';
import { HeaderView } from './modules/common/HeaderView';
import 'primereact/resources/primereact.min.css';
import { PrimeReactProvider } from 'primereact/api';
import { SCERSTheme } from './SCERSPrimeReactTheme.jsx';
import './index.css';

// Open Sans Variable Font 300-800
import '@fontsource-variable/open-sans';
import { AppConfig } from './config/AppConfig';
import useAsyncEffect from 'use-async-effect';
import { Appl } from './core/Appl';
import { AlertBox, AlertPlacement } from './core/components/dialogs/AlertBox';
import { Spinner } from './core/components/dialogs/Spinner';
import { ConfirmBox } from './core/components/dialogs/ConfirmBox';
import { MessageBox } from './core/components/dialogs/MessageBox';
import SidebarViewNavigation from './modules/common/SidebarViewNavigation';
import { FooterView } from './modules/common/FooterView';
import { IdleTimer } from './core/components/actions/IdleTimer';

AppConfig.init();

const App: React.FC = observer(() => {
  useAsyncEffect(async () => {
    Appl.Setting.AppVersion = await AppConfig.instance.getReleaseInfo();
    Appl.Logger.logInfo(`App Version: ${Appl.Setting.AppVersion}`);
  }, []);

  const [menuCollapsed, setMenuCollapsed] = React.useState(false);

  return (
    <PrimeReactProvider value={SCERSTheme as any}>
      <HeaderView />

      <div
        className="group/sidebar-wrapper flex min-h-svh-header w-full has-[[data-variant=inset]]:bg-sidebar"
        style={
          {
            '--sidebar-width': '16rem',
            '--sidebar-width-icon': '4rem',
          } as React.CSSProperties
        }
      >
        {/* Sidebar omitted as before */}

        <div className="relative flex min-h-svh-header flex-1 flex-col">

          <div className="flex-1 overflow-hidden">
            <Spinner />

            <IdleTimer
              idleTimeoutSeconds={Appl.Setting.IdleTimeoutSeconds}
              idlePromptTimeoutSeconds={Appl.Setting.IdlePromptTimeoutSeconds}
              idleRedirectUrl={'/logout?mode=session&from=member'}
              disabled={false}
            />

            <AlertBox placement={AlertPlacement.TopRight} />
            <ConfirmBox />
            <MessageBox />

            <Outlet />
          </div>

          <FooterView version={Appl.Setting.AppVersion} />

        </div>
      </div>
    </PrimeReactProvider>
  );
});

export default App;
